import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolingHistoryComponent } from './tooling-history/tooling-history.component';
import { Route } from '@angular/router';
import {
  GridV2Module,
  RadioV2Module,
  ButtonV2Module,
  PagesV2Module,
  SpinnerV2Module,
  AssetsModule,
  IconV2Module,
  DateV2Module,
  MultiselectV2Module,
  CheckboxV2Module,
  NotificationsV2Module,
} from '@schenck/rotec-components';

import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import {
  ToolingHistorySearchService,
  ToolingHistorySearchApi,
} from './tooling-history-search.service';
import { ToolingHistorySettingsApi } from './tooling-history-settings.api';
import { ToolingHistorySettingsService } from './tooling-history-settings.service';
import { ToolingHistoryModalComponent } from './tooling-history-modal/tooling-history-modal.component';

export const toolingHistoryRoutes: Route[] = [{ path: '', component: ToolingHistoryComponent }];

@NgModule({
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    GridV2Module,
    RadioV2Module,
    ButtonV2Module,
    IconV2Module,
    DateV2Module,
    MultiselectV2Module,
    CheckboxV2Module,
    PagesV2Module,
    SpinnerV2Module,
    NotificationsV2Module,
    AssetsModule,
    ToolingHistoryComponent,
    ToolingHistoryModalComponent,
  ],
  providers: [
    ToolingHistorySearchApi,
    ToolingHistorySearchService,
    ToolingHistorySettingsApi,
    ToolingHistorySettingsService,
  ],
})
export class ToolingHistoryModule {}
